import { List } from "immutable";
import { MobileBaseObject } from "./mobile-base-object";
import { ActivityActor } from "./activityActor";
import * as moment from 'moment';

export interface IAvailability extends MobileBaseObject {
  name: string;
  type: string;
  dateKey: string;
  activityID: string;
  userMappingID: string;
  start: Date;
  group: string;
  duration: any;
  skill: string;
  comment: string;
  meta: string;
  activities: List<ActivityActor>;
  checkedin: boolean;
  displayOrder: number;

}

export class Availability extends MobileBaseObject implements IAvailability {

  public name: string;
  public type: string;
  public dateKey: string;
  public activityID: string;
  public userMappingID: string;
  public start: Date;
  public group: string;
  public duration: any;
  public skill: string;
  public comment: string;
  public meta: string;
  public activities: List<ActivityActor>;
  public checkedin: boolean;
  public lateToWork: boolean;
  public displayOrder: number;
 

  public constructor(
    availability: Partial<IAvailability> = null


  ) {
    super();
    if (availability != null) {
      this.name = availability.name;
      this.type = availability.type;
      this.dateKey = availability.dateKey;
      this.activityID = availability.activityID;
      this.userMappingID = availability.userMappingID;
      this.group = availability.group;
      this.start = new Date(availability.start);
      this.duration = availability.duration;
      this.skill = availability.skill;
      this.comment = availability.comment;
      this.meta = availability.meta;
      this.activities = availability.activities;

      this.id = availability.id;
      this.createdAt = availability.createdAt;
      this.updatedAt = availability.updatedAt;
      this.displayOrder = availability.displayOrder;
    }
  }

  public get durationMinutes(): number {
    var datetime = new Date('1970-01-01T' + this.duration + 'Z');
    return (datetime.getTime()/1000/60);
  }

  public set durationMinutes(value: number) {
    var end = new Date('1970-01-01T00:00:00Z');;
    this.duration = formatTime(new Date(end.getTime() + (end.getTimezoneOffset() * 60 * 1000) + (value * 60 * 1000)));
  }

  public get end(): Date {
    return moment(this.start).add(this.durationMinutes, "minutes").toDate();
  }

  public set end(value: Date) {
    this.duration = formatDiffTime(this.start, value);
  }

  public get skillExpanded(): string[] {
    return JSON.parse(this.skill) as string[];
  }

  public get isAir(): boolean {
    return this.skillExpanded.findIndex(x => x == "AIR") >= 0;
  }

  public get isLand(): boolean {
    return this.skillExpanded.findIndex(x => x == "LAND") >= 0;
  }

  public set skillExpanded(value: string[]) {
    this.skill = JSON.stringify(value);
  }

  public get metaExpanded(): AvailabilityMeta {
    return Availability.toMetaExpanded(this.meta);
  }

  public set metaExpanded(value: AvailabilityMeta) {
    this.meta = JSON.stringify(value);
  }

  // returns true if start or end is within any availability start/end
  public isWorkingWithinTimespan(start: Date, end: Date) {
    if (!start || !end) {
      return false;
    }

    const startTime = start.getTime();
    const endTime = end.getTime();

    // Overlap check: [aStart, aEnd] overlaps [bStart, bEnd]
    return startTime <= this.end.getTime() && endTime >= this.start.getTime();

  }

  // returns true if startTime and endTime is withing workshift
  public isWorkingByTime(startTime: number, endTime: number) {

    if (this.start.getTime() <= startTime && this.end.getTime() >= endTime) {
      return true;
    }

    return false;
  }

  public isWorking(eventDate: Date): boolean {
    return this.isWorkingByTime(eventDate.getTime(), eventDate.getTime())
  }

  public static toMetaExpanded(meta: string): AvailabilityMeta {
    return JSON.parse(meta) as AvailabilityMeta;
  }

  public static toTypeSafe(availability: Availability): Availability {

    let typeSafeAvailability = new Availability();
    typeSafeAvailability.name = availability.name;
    typeSafeAvailability.type = availability.type;
    typeSafeAvailability.dateKey = availability.dateKey;
    typeSafeAvailability.activityID = availability.activityID;
    typeSafeAvailability.userMappingID = availability.userMappingID;
    typeSafeAvailability.group = availability.group;
    typeSafeAvailability.start = new Date(availability.start);
    typeSafeAvailability.duration = availability.duration;
    typeSafeAvailability.skill = availability.skill;
    typeSafeAvailability.comment = availability.comment;
    typeSafeAvailability.meta = availability.meta;
    typeSafeAvailability.activities = availability.activities;
    typeSafeAvailability.id = availability.id;
    typeSafeAvailability.createdAt = availability.createdAt;
    typeSafeAvailability.updatedAt = availability.updatedAt;
    typeSafeAvailability.displayOrder = availability.displayOrder;

    return typeSafeAvailability;
  }
  
}

export class AvailabilityMeta {
  public BusNumber: string;
  public BusRegNumber: string;
  public ActivityName: string;
}

const leadingZero = (num) => `0${num}`.slice(-2);

const formatDiffTime = (start: Date, end: Date) =>
  [end.getHours() - start.getHours(), end.getMinutes() - start.getMinutes(), end.getSeconds() - start.getSeconds()]
    .map(leadingZero)
    .join(':') + ".0000000";

const formatTime = (date: Date) =>
  [date.getHours(), date.getMinutes() , date.getSeconds() ]
    .map(leadingZero)
    .join(':') + ".0000000";
